import type { FaireProductEntity } from "../../entity_types/product";

export const p_v9fubp6ypc: FaireProductEntity = {
  token: "p_v9fubp6ypc",
  type: "product",
  name: "Pearls Bracelet Gold plated box chain adjustable",
  brandToken: "b_b5e3cyh82h",
  brandName: "Amady Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/d75584ea1d13e0d585513f1ea6047482caa8daa87bfd94d7b5e52bb54b6cd3d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ddfe0f279a8d0995359735f2d539c773f61c2fd918f35a80e048c05c157a639.jpeg",
    "https://cdn.faire.com/fastly/d5becc5260e6b0ff23ecbcb5355572fd8c97c784c5689e7e0b6c20e9f6ba6afe.jpeg",
    "https://cdn.faire.com/fastly/5e13c801c81b4b75c1a0cace290281293441b1eb7426b15ac0bd37d68867033e.jpeg",
    "https://cdn.faire.com/fastly/6f86dbf4c76482ef83a049ef4eecb4c9910088633352a092f773bfc1fb86b851.jpeg",
    "https://cdn.faire.com/fastly/f1a20614ea2bca0d18b13a0d2b442bc4fed71643c2f5fcf35bca6562459f0be1.jpeg",
    "https://cdn.faire.com/fastly/ec5be6915c28dd9bb1230a66b19b9947dba3112b505e67d4eb85d4fa8832d7bd.jpeg",
  ],
  priceDollars: 15,
  description:
    '• Beautiful genuine Freshwater Pearls + 18k gold plated box chain Bracelet. The perfect amount of edginess and classic in just one piece.\n• Great to wear by itself or layered with more bracelets from the collection.\n\n• 18k Gold Plated, stainless steel.\n\n• Measures 6" + 2" extension.\n\n• Waterproof / Water-resistant',
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:49.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
